import { render, staticRenderFns } from "./EventDetailForClasses.vue?vue&type=template&id=2ebf636e&"
import script from "./EventDetailForClasses.vue?vue&type=script&lang=js&"
export * from "./EventDetailForClasses.vue?vue&type=script&lang=js&"
import style0 from "./EventDetailForClasses.vue?vue&type=style&index=0&id=2ebf636e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports